import { useState } from 'react';
import { connectToInstagram, disconnectInstagram, getInstagramAccount } from '../lib/instagram';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';
import InstagramLoginPopup from './InstagramLoginPopup';

export default function InstagramConnect() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const { data: account, isLoading } = useQuery(
    'instagramAccount',
    getInstagramAccount,
    {
      enabled: !!user,
    }
  );

  const connectMutation = useMutation(connectToInstagram, {
    onSuccess: () => {
      queryClient.invalidateQueries('instagramAccount');
      toast.success('Successfully connected to Instagram');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to connect to Instagram');
    }
  });

  const disconnectMutation = useMutation(disconnectInstagram, {
    onSuccess: () => {
      queryClient.invalidateQueries('instagramAccount');
      toast.success('Successfully disconnected from Instagram');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to disconnect from Instagram');
    }
  });

  if (!user) {
    return (
      <button
        onClick={() => toast.error('Please sign in to connect Instagram')}
        className="btn btn-primary opacity-50 cursor-not-allowed"
      >
        Connect Instagram
      </button>
    );
  }

  if (isLoading) {
    return (
      <button className="btn btn-primary opacity-50 cursor-wait">
        Loading...
      </button>
    );
  }

  const handleConnect = () => {
    setShowLoginPopup(true);
  };

  const handleDisconnect = () => {
    disconnectMutation.mutate();
  };

  return (
    <>
      <button
        onClick={account?.connected ? handleDisconnect : handleConnect}
        className="btn btn-primary"
        disabled={connectMutation.isLoading || disconnectMutation.isLoading}
      >
        {connectMutation.isLoading || disconnectMutation.isLoading ? (
          'Processing...'
        ) : account?.connected ? (
          'Disconnect Instagram'
        ) : (
          'Connect Instagram'
        )}
      </button>

      {showLoginPopup && (
        <InstagramLoginPopup
          onClose={() => setShowLoginPopup(false)}
          onSuccess={() => {
            setShowLoginPopup(false);
            connectMutation.mutate();
          }}
        />
      )}
    </>
  );
}